import { makeStyles } from '@material-ui/core';
import { palette } from '../../settings/themes/colors';

const useActiveFilterStyles = makeStyles(() => ({
  activeFilter: {
    '&[class*="MuiOutlinedInput"]:not(.Mui-disabled)>fieldset': {
      borderColor: palette.cerulean
    },
    '& [class*="MuiOutlinedInput"]:not(.Mui-disabled)>fieldset': {
      borderColor: palette.cerulean
    }
  }
}));

export const useActiveFilterClasses = () => useActiveFilterStyles();

export const isFilterActive = (value, defaultValue) => {
  if (Array.isArray(value)) return value.length > 0;

  if (value === null || value === undefined || value === '') return false;

  return value !== defaultValue;
};
